<template>
  <ERow justify="center" align="stretch">
    <ECol cols="12" class="py-0">
      <v-data-table
        ref="posthogEventsStatsTable"
        :headers="headers"
        :items="items"
        :sort-by.sync="options.sortBy"
        :sort-desc.sync="options.sortDesc"
        :loading="loading"
        loading-text="Loading..."
        :options.sync="internalOptions"
        :server-items-length="total"
        :mobile-breakpoint="0"
        item-key="index"
        :footer-props="footerProps"
        dense
        must-sort
        calculate-widths
        fixed-header
        class="custom-data-table elevation-1"
        :height="height"
      >
        <!-- Named slots pass-through -->
        <template v-for="(_, slotName) in $scopedSlots" #[slotName]="scope">
          <slot :name="slotName" v-bind="scope" />
        </template>

        <!-- Default slot pass-through -->
        <template #default="scope">
          <slot v-bind="scope" />
        </template>
      </v-data-table>
    </ECol>
  </ERow>
</template>

<script>
export default {
  name: "PosthogEventsStatsTable",
  props: {
    footerProps: {
      type: Object,
      default: () => ({
        "items-per-page-options": [20, 50, 100],
        "show-current-page": true,
        "show-first-last-page": true,
      }),
    },
    headers: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      internalOptions: {},
    }
  },
  watch: {
    internalOptions: {
      handler(newVal) {
        this.$emit("update:options", newVal)
      },
      deep: true,
    },
    options: {
      handler(newVal) {
        this.internalOptions = newVal
      },
      deep: true,
    },
  },
}
</script>
